import { Component, h, Method, Prop, State } from "@stencil/core";

@Component({
    tag: "ux-mobile-table",
    styleUrl: "mobile-table.scss",
    shadow: false
})
export class MobileTable {
    /** ux-table element */
    @Prop() readonly uxTable: HTMLUxTableElement | null;
    /** is table sortable */
    @Prop() readonly sortable: boolean = false;
    /** label for ux-select */
    @Prop() readonly selectLabel: string = "";
    /** choose no-click-selector if an icon (other than the accordion icon) is used in the fixed-mobile-col */
    @Prop() readonly noClickSelector: string = "";

    private table: HTMLTableElement | null = null;

    /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
    @State() rows: any[] = [];

    @State() sorters: {
        text: string;
        trigger: () => void;
        selected: boolean;
    }[] = [];

    /** this should be called when the source content is changed */
    @Method()
    async update() {
        if (this.uxTable == null) {
            return;
        }
        this.table = this.uxTable.querySelector("table");
        if (this.table == null) {
            return;
        }
        this.rows = Array.from(this.table.querySelectorAll("tr:not(thead tr)")).filter((tr) => tr.querySelector("td") !== null);

        const sortElements = Array.from(this.table.querySelectorAll<HTMLUxTableSortElement>("th ux-table-sort"));
        this.sorters = [];
        sortElements.forEach((el) => {
            this.sorters.push({
                text: el.textContent + " ↓",
                trigger: () => el.sortDesc(),
                selected: el.sortedDirection === "desc"
            });
            this.sorters.push({
                text: el.textContent + " ↑",
                trigger: () => el.sortAsc(),
                selected: el.sortedDirection === "asc"
            });
        });
    }

    componentDidLoad() {
        this.update();
    }

    render() {
        if (this.table === null) {
            return null;
        }
        const titleColIndex =
            this.uxTable.mobileTitleIndex === undefined ? this.uxTable.fixedColIndex : this.uxTable.mobileTitleIndex;

        const columnTitles = Array.from(this.table.querySelectorAll("tr th"));
        const columnTitlesFiltered = columnTitles.filter(
            (title) => title !== this.table.querySelector(`tr th:nth-child(${titleColIndex + 1})`)
        );
        const ColumnTitlesHtml = columnTitlesFiltered.map((title) => {
            const sorter = title.querySelector(".ux-table-sort__text");
            if (sorter !== null) {
                return sorter.innerHTML;
            }
            return title.innerHTML;
        });
        const fixedColTitle = this.table.querySelector(`th:nth-child(${titleColIndex + 1})`);
        const fixedSorter = fixedColTitle.querySelector(".ux-table-sort__text");
        const fixedColTitleHtml = fixedSorter !== null ? fixedSorter.innerHTML : fixedColTitle.innerHTML;

        const baseClass = "ux-mobile-table";

        return (
            <div class={baseClass}>
                {this.sortable && (
                    <ux-select
                        class={`${baseClass}__select`}
                        label={this.selectLabel}
                        onUxSelectChange={(e) => {
                            const filteredSorters = this.sorters.filter((sorter) => sorter.text === e.detail);
                            if (filteredSorters.length > 0) {
                                const sorter = filteredSorters[0];
                                sorter.trigger();
                            }
                        }}
                    >
                        {this.sorters.map((sorter) => (
                            <option selected={sorter.selected}>{sorter.text}</option>
                        ))}
                    </ux-select>
                )}
                {this.rows.map((row) => {
                    const accordionTitle = row.querySelector(`td:nth-child(${titleColIndex + 1})`);

                    const cells = Array.from(row.querySelectorAll(`td`));
                    const cellsFiltered = cells.filter((cell) => cell !== row.querySelector(`td:nth-child(${titleColIndex + 1})`));
                    return (
                        <ux-accordion class={`${baseClass}__accordion`} no-click-selector={this.noClickSelector}>
                            <span slot="title" class={`${baseClass}__accordion-title`}>
                                {fixedColTitle !== null ? (
                                    <span
                                        innerHTML={fixedColTitleHtml}
                                        class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-margin-bottom-5"
                                    ></span>
                                ) : (
                                    <span></span>
                                )}
                                {accordionTitle !== null ? <span innerHTML={accordionTitle.innerHTML}></span> : <span></span>}
                            </span>
                            <table class={`${baseClass}__accordion-table`}>
                                {cellsFiltered.map((cell: HTMLElement, index: number) => {
                                    return (
                                        <tr class={`${baseClass}__accordion-row`}>
                                            <span
                                                innerHTML={ColumnTitlesHtml[index]}
                                                class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase ux-u-margin-bottom-5"
                                            ></span>
                                            <span innerHTML={cell.innerHTML} />
                                        </tr>
                                    );
                                })}
                            </table>
                        </ux-accordion>
                    );
                })}
            </div>
        );
    }
}
